import {
    type TFunction,
} from 'i18next'

import {
    ApiError,
} from './api-error'

export function translateApiError(
    error: ApiError,
    t: TFunction,
): string {
    if (!error.errorCode) {
        return error.message
    }

    return t(
        error.errorCode as never,
        {
            defaultValue: error.message,
        },
    )
}